const e = e => {
    switch (typeof e) {
      case "string":
      case "number":
        return e;

      case "object":
        if (e) return e.label;
    }
    if ("production" !== process.env.NODE_ENV) throw console.log({
        option: e
    }), new Error("default option label getter failed to guess.");
    return "";
};

export { e as default };
//# sourceMappingURL=index.js.map
